interface FiltersProps {
  filters: {
    purpose: string;
    floor: string;
    minSize: string;
    maxSize: string;
    status: string;
  };
  onFiltersChange: (f: FiltersProps['filters']) => void;
}

const purposes = [
  'Pharmacy', 'Clothing Store', 'Confectionary', 'Electronics', 'Groceries', 'Beauty Salon',
  'Bookstore', 'Sports Goods', 'Jewelry', 'Home & Garden', 'Office', 'Gaming Hub', 'Mens Wear',
  'Womens Wear', 'Childrens Wear', 'Baby Wear', 'Shoes', 'Bags', 'Accessories', 'Watches',
  'PPE', 'Photo Studio', 'Hand Bags', 'Uniforms & Corporate Ware', 'Chinese', 'Electric Appliances',
  'Printing', 'Perfumes', 'Branding', 'Tailor', 'Linen', 'Braids & Hair Products', 'Deco & Homeware',
  'Cosmetics', 'Diapers', 'Other'
];

export default function ShopFilters({ filters, onFiltersChange }: FiltersProps) {
  const update = (key: keyof FiltersProps['filters'], value: string) => {
    onFiltersChange({ ...filters, [key]: value });
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
      <div>
        <label className="block text-sm font-medium text-ink mb-1.5">Type</label>
        <select
          value={filters.purpose}
          onChange={(e) => update('purpose', e.target.value)}
          className="w-full px-3 py-2.5 rounded-xl border border-stone-200 bg-surface text-ink focus:ring-2 focus:ring-primary"
        >
          <option value="">All</option>
          {purposes.map((p) => (
            <option key={p} value={p}>{p}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium text-ink mb-1.5">Floor</label>
        <select
          value={filters.floor}
          onChange={(e) => update('floor', e.target.value)}
          className="w-full px-3 py-2.5 rounded-xl border border-stone-200 bg-surface text-ink focus:ring-2 focus:ring-primary"
        >
          <option value="">All</option>
          <option value="Ground">Ground</option>
          <option value="First">First</option>
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium text-ink mb-1.5">Min sqm</label>
        <input
          type="number"
          step="0.1"
          value={filters.minSize}
          onChange={(e) => update('minSize', e.target.value)}
          placeholder="Min"
          className="w-full px-3 py-2.5 rounded-xl border border-stone-200 bg-surface text-ink focus:ring-2 focus:ring-primary"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-ink mb-1.5">Max sqm</label>
        <input
          type="number"
          step="0.1"
          value={filters.maxSize}
          onChange={(e) => update('maxSize', e.target.value)}
          placeholder="Max"
          className="w-full px-3 py-2.5 rounded-xl border border-stone-200 bg-surface text-ink focus:ring-2 focus:ring-primary"
        />
      </div>
      <div className="flex items-end">
        <button
          type="button"
          onClick={() => onFiltersChange({
            purpose: '',
            floor: '',
            minSize: '',
            maxSize: '',
            status: 'available'
          })}
          className="w-full py-2.5 rounded-xl border border-stone-300 text-ink font-medium hover:bg-surface-muted"
        >
          Clear
        </button>
      </div>
    </div>
  );
}
